import { ENV } from "@type/config";

interface EnvCheckerProps {
  envs: string[];
  /**
   * If true: check if the current active ENV exists or no with the given envs
   * IF false: check if the current active ENV should be not exists in the given envs
   */
  validWhen?: boolean;
}

export const envChecker = ({ envs, validWhen = true }: EnvCheckerProps) => {
  if (validWhen) {
    return envs.includes(ENV);
  }

  return !envs.includes(ENV);
};
